<div class="card">
  <fa-icon [icon]="icon" size="{{iconSize}}x"></fa-icon>
  <h3 class="text-center" [innerHTML]="title | safeHtml"></h3>
  <div class="col-auto text-center" [innerHTML]="body | safeHtml"></div>
</div>